import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// Wipes the local metadata + blob stores (used on logout); the backend is untouched.
export class DeleteUserGeometriesLocalDataUseCase implements UseCase<void, Promise<Result<void>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(): Promise<Result<void>> {
    try {
      return await this.repository.clearLocalData()
    } catch (error) {
      return Result.fail(error)
    }
  }
}
